module.exports = __webpack_public_path__ + "img/dashboard_total_payable.3c59294.png";